import Model from './Model';

export default class Slider extends Model {
    readonly id: number;
    readonly name: string;
    readonly slug: string;
    readonly slider_items_count: number;

    constructor(data: any) {
        super();
        this.assignDataToProps(data, ['id', 'name', 'slug', 'slider_items_count']);
    }
}
